//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';
import DpIcon from '../icon/Icon.vue';

export default {
  name: 'DpBadge',
  components: {
    DpIcon,
  },
  mixins: [Tooltip],
  props: {
    value: { type: [String, Number], default: '' },
    prefix: { type: String, default: null },
    suffix: { type: String, default: null },
    text: { type: String, default: null },
    size: { type: String, default: 'normal' },
    state: { type: [Number, String], default: 'none' },
    icon: { type: String, default: null },
    fullWidth: { type: Boolean, default: false },
  },
  computed: {
    displayText() {
      const {
        text,
        value,
        prefix,
        suffix,
      } = this;
      if (text !== null) {
        return text;
      }
      return `${prefix}${value}${suffix}`;
    },
    stateClass() {
      const classMap = {
        GREEN: 'success',
        AMBER: 'warning',
        RED: 'error',
      };
      return classMap[this.state] || this.state;
    },
  },
};
